import { render, staticRenderFns } from "./IndexProduit.vue?vue&type=template&id=64729530&"
import script from "./IndexProduit.vue?vue&type=script&lang=js&"
export * from "./IndexProduit.vue?vue&type=script&lang=js&"
import style0 from "./IndexProduit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports